import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { ErpSidebarAction } from '../../types/erp-sidebar-action.type';

@Component({
  selector: 'erp-sidebar-item',
  imports: [TooltipModule, RouterModule],
  templateUrl: './erp-sidebar-item.component.html',
  styleUrl: './erp-sidebar-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErpSidebarItemComponent { 
  public tooltip = input<string>()
  public routerLink = input<string>()
  public routerLinkActiveClass = input<string | string[]>('router-link-active')
  public itemClass = input<string>()
  public action = input<ErpSidebarAction | undefined>()

  onClick(): void {
    const fn = this.action()
    if (fn) fn()
  }
}